<template>
  <div class="income-box">
    <!-- <div class="text-size">
      <van-row class="text-row">
        <van-col class="span-title" span="11">预期收入（元）</van-col>
        <van-col class="span-weight" span="6">255555</van-col>
        <van-col class="span-status" span="7">财务审核中</van-col>
      </van-row>
      <van-row class="text-row">
        <van-col class="span-title" span="11">放款金额（万元）</van-col>
        <van-col span="6">255555</van-col>
      </van-row>
      <van-row class="text-row">
        <van-col class="span-title" span="11">订单号</van-col>
        <van-col span="6">255555</van-col>
      </van-row>
      <van-row class="text-row">
        <van-col class="span-title" span="11">产品名称</van-col>
        <van-col span="6">255555</van-col>
      </van-row>
      <van-row class="text-row">
        <van-col class="span-title" span="11">订单时间</van-col>
        <van-col span="6">255555</van-col>
      </van-row>
      <van-row class="text-row">
        <van-col class="span-title" span="11">客户姓名</van-col>
        <van-col span="6">张三</van-col>
      </van-row>
    </div>-->
    <van-cell-group inset v-for="(item,index) in dataList" :key="index">
      <van-cell title="预期收入（元）" :value="item.expectAmount">
        <template #extra>
          <div class="status">预期审核中</div>
        </template>
      </van-cell>
      <van-cell title="放款金额（万元）" :value="item.actualAmount" />
      <van-cell title="订单号" :value="item.orderId" />
      <van-cell title="产品名称" :value="item.productName" />
      <van-cell title="订单时间" :value="item.orderTime" />
      <van-cell title="客户姓名" :value="item.cusName" />
    </van-cell-group>
  </div>
</template>

<script>
import URL from "@/api/api";
export default {
  data() {
    return {
      total: 900000,
      page: 1,//当前页
      size: 10,//当前页数
      dataList: []
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      let that = this
      let data = {
        agentMobile: localStorage.getItem('phoneNo'),
        page: that.page,
        size: that.size
      }
      that.$fetchPost(URL.postOrders.url, that.$toFormData(data)).then(res => {
        if (res.data.code == 20000) {
          that.dataList = res.data.data.records
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.income-box{
  overflow: hidden;
}
.van-cell-group--inset {
  margin: 15px;
}
.van-cell__value{
  text-align: left;
}
.status{
  position: absolute;
  right: 0.15rem;
  color: red;
}
// .text-row {
//   margin-top: 10px;
//   padding: 0 10px;
//   text-align: center;
//   font-size: 0.37rem;
// }
// .span-weight {
//   font-weight: 600;
// }
// .span-title {
//   text-align: left;
// }
// .span-status {
//   font-size: 0.3rem;
//   color: blue;
// }
// .text-size {
//   margin-top: 25px;
// }
</style>